// extracted by mini-css-extract-plugin
module.exports = {"PartnershipsWrapper":"PartnershipsWrapper_PartnershipsWrapper__Zqmfs"};